import React from "react";
import { InputBaseProps } from "..";
import { SanityInputCheckboxProps } from "../../../models/form/SanityFormInputField";
import ControlledCheckbox from "../../ControlledInputs/ControlledCheckbox";
import { useFieldValidator } from "../Validation";
import InputContainer from "./InputContainer";
import { useFieldCustom } from "./useFieldCustom";

export type CheckboxProps = InputBaseProps<SanityInputCheckboxProps>;

const Checkbox = (props: CheckboxProps) => {
  const { inputContainerVariant, name, label = "", readonly, validation } = props;

  const validator = useFieldValidator(validation);

  const [field, meta] = useFieldCustom({
    name,
    validate: validator,
    type: "checkbox"
  });

  return (
    <InputContainer meta={meta} variant={inputContainerVariant}>
      <ControlledCheckbox
        {...field}
        error={meta.touched && !!meta.error}
        label={label}
        readonly={readonly}
      />
    </InputContainer>
  );
};

export default Checkbox;
